// extracted by mini-css-extract-plugin
export default {"sticky":"ProfitAndLossProjectionFormBody_sticky__6p7SV","stickyTop":"ProfitAndLossProjectionFormBody_stickyTop__jmrT-"};